import { useQuery } from "@tanstack/react-query";

import { profileQueryOptions } from "@/domains/profile/factories/profile-query-options";

export const useProfile = () => {
  return useQuery({
    ...profileQueryOptions.current,
    staleTime: 1000 * 60,
  });
};
